import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-delete-common-dialog',
  templateUrl: './delete-common-dialog.component.html',
  styleUrl: './delete-common-dialog.component.css'
})
export class DeleteCommonDialogComponent {

  constructor(
    public dialogRef: MatDialogRef<any>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit(): void {
  }
  
  closeDialog() {
    this.dialogRef.close({status: true});
  }

}
